// import { SparkRenderController } from './spark-render-controller.js';
import { GS3dRenderController } from './gs-3d-render-controller.ts';
export function getGaussianSplattingRender(sceneController: any): GS3dRenderController {
  const engine: string | null = localStorage.getItem('engine');
  console.log('get model controller ', engine);
  localStorage.removeItem('engine');
  // switch (engine) {
  //   case EngineConfig.Spark:
  //     return new SparkRenderController(sceneController);
  //   case EngineConfig.GaussianSplats3D:
  //     return new GS3dRenderController(sceneController);
  //   default:
  return new GS3dRenderController(sceneController);
}
